const { is } = require('../../is/is')

const { consts } = require('./consts')

/**
 * Visszaadja, hogy két dátum között mennyi nap van.
 * @param {string | number | Date} start - A kezdődátum.
 * @param {string | number | Date} end - A végdátum.
 * @param {boolean} [isMinusValid=false] - Lehet negatív szám is?
 * @returns {number} A két dátum közötti napok száma.
 */
module.exports.getDaysCountBetweenDates = function getDaysCountBetweenDates (start, end, isMinusValid = false) {
  const date1 = is.instanceOf(start, Date) ? start : new Date(start)
  const date2 = is.instanceOf(end, Date) ? end : new Date(end)

  const oneDay = consts.DAY_IN_MS

  const rawDiff = (date1.getTime() - date2.getTime())
  const diff    = isMinusValid ? rawDiff : Math.abs(rawDiff)
  const count   = Math.round(diff / oneDay)

  return count
}
